/*eslint-disable*/
import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import Table from './TableHead'
import Row from './Row'
import {Widths,TableClass} from './constants'

export default class Group extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true
    }
  }

  toggleCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed
    })
  };

  render() {
    const {data,...rest} = this.props;
    const {collapsed} = this.state;
    return (
      collapsed ? <Collapsed {...data[0]} onSelect={this.toggleCollapse} {...rest} /> : <ContractGroup onSelect={this.toggleCollapse} {...{data}} {...rest}/>
    );
  }
}

Group.propTypes = {
  data: PropTypes.array
};

const Collapsed = ({gen_contractnumber_tb,gen_vendorname_tb,onSelect}) => {
  return (
    <table className={TableClass}>
      <tbody>
      <tr className="contract-group" onClick={onSelect}>
        <td width={Widths.contractNo}>{gen_contractnumber_tb}</td>
        <td width={Widths.vendor}>{gen_vendorname_tb}</td>
        <td width={Widths.project}>&nbsp;</td>
        <td width={Widths.poNo}>&nbsp;</td>
        <td width={Widths.poAmount}>&nbsp;</td>
        <td width={Widths.amount}>&nbsp;</td>
        <td width={Widths.balance}>&nbsp;</td>
      </tr>
      </tbody>
    </table>
  );
};
Collapsed.propTypes = {
  onSelect: PropTypes.func
};
Collapsed.defaultProps = {};

const ContractGroup = ({data,onSelect,...rest}) => {
  const {gen_contractnumber_tb,gen_vendorname_tb} = data[0];
  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <h3 className="panel-title"><a onClick={onSelect} style={{cursor:'pointer'}}>{gen_contractnumber_tb}: {gen_vendorname_tb}</a></h3>
      </div>
      <div className="panel-body">
        <Table>
          {data.map((row,i)=>{
            return <Row key={`contract-group-row-${i}`} {...row} {...rest} />
          })}
        </Table>
      </div>
    </div>
  );
};
ContractGroup.propTypes = {
  onSelect: PropTypes.func,
  data: PropTypes.array
};
ContractGroup.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/Group.jsx